export default __webpack_public_path__ + "static/char-17-anr-d030be6f27407b439ee6296c3b5d0436.webp";